module.exports = __webpack_public_path__ + "static/media/crow.b64b9b57.png";